import React from 'react';

interface ScopeToggleProps {
  value: 'campaigns' | 'adGroups' | 'ads';
  onChange: (k: 'campaigns' | 'adGroups' | 'ads') => void;
  // Когда true — блокируем смену значения: разрешена только активная кнопка
  lockSelection?: boolean;
}

export function ScopeToggle({ value, onChange, lockSelection = false }: ScopeToggleProps) {
  const items: Array<{ k: 'campaigns' | 'adGroups' | 'ads'; label: string }> = [
    { k: 'campaigns', label: 'Кампании' },
    { k: 'adGroups', label: 'Группы объявлений' },
    { k: 'ads', label: 'Объявления' },
  ];

  return (
    <div className="scope-toggle" role="group" aria-label="Что проверяем?">
      {items.map((it, idx) => (
        <button
          key={it.k}
          type="button"
          className={
            `scope-btn ${idx === 0 ? 'is-first' : ''} ${idx === items.length - 1 ? 'is-last' : ''} ${value === it.k ? 'is-active' : ''}`
          }
          onClick={() => !lockSelection && onChange(it.k)}
          disabled={lockSelection && it.k !== value}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
